import { defineMessages } from "react-intl";

const messages = defineMessages({
    welcome: {
        id: 'Tervetuloa!',
        defaultMessage: 'Tervetuloa!'
    },
    retrieveInvoiceTitle: {
        id: 'Hae lasku',
        defaultMessage: 'Hae lasku'
    },
    retrieveInvoiceDescription: {
        id: 'Oletko saanut laskun, joka ei näy listauksessa? Syynä voi olla laskun puuttuvat tunnistetiedot. Voit hakea laskun antamalla sen tiedot tai MyRopo-tunnuksen.',
        defaultMessage: 'Oletko saanut laskun, joka ei näy listauksessa? Syynä voi olla laskun puuttuvat tunnistetiedot. Voit hakea laskun antamalla sen tiedot tai MyRopo-tunnuksen.'
    },
    returnPaymentTitle: {
        id: 'Ilmoita tilinumero',
        defaultMessage: 'Ilmoita tilinumero'
    },
    returnPaymentDescription: {
        id: 'Odotatko maksunpalautusta laskusta tai liikamaksusta? Voit ilmoittaa tilinumerosi MyRopo-tunnuksella, jonka löydät lähettämästämme kirjeestä.',
        defaultMessage: 'Odotatko maksunpalautusta laskusta tai liikamaksusta? Voit ilmoittaa tilinumerosi MyRopo-tunnuksella, jonka löydät lähettämästämme kirjeestä.'
    },
    tabInvoicesTitle: {
        id: 'Avoimet laskut',
        defaultMessage: 'Avoimet laskut'
    },
    tabArchiveTitle: {
        id: 'Arkisto',
        defaultMessage: 'Arkisto'
    },
    searchFieldPlaceholder: {
        id: 'Etsi laskua listauksesta',
        defaultMessage: 'Etsi laskua listauksesta'
    },
    nextStep: {
        id: 'Seuraava vaihe',
        defaultMessage: 'Seuraava vaihe'
    },
    send: {
        id: 'Lähetä',
        defaultMessage: 'Lähetä'
    },
    goBack: {
        id: 'Palaa takaisin',
        defaultMessage: 'Palaa takaisin'
    },
    paymentReturnDetailsTitle: {
        id: 'Maksunpalautuksen tiedot',
        defaultMessage: 'Maksunpalautuksen tiedot'
    },
    paymentReturnDetailsDescription: {
        id: 'Alla maksunpalautustasi koskevat tiedot.',
        defaultMessage: 'Alla maksunpalautustasi koskevat tiedot.'
    },
    bankAccountDetailsTitle: {
        id: 'Pankkitilin tiedot',
        defaultMessage: 'Pankkitilin tiedot'
    },
    bankAccountDetailsDescription: {
        id: 'Ole hyvä ja anna pankkitilisi tiedot maksunpalautusta varten.',
        defaultMessage: 'Ole hyvä ja anna pankkitilisi tiedot maksunpalautusta varten.'
    },
    bankAccountHolderName: {
        id: 'Tilinumeron haltijan nimi',
        defaultMessage: 'Tilinumeron haltijan nimi'
    },
    bankAccountHolderInfo: {
        id: 'Huomioithan, että jos palautuksen saajana on yritys, tulee tilinumeron haltijan nimeksi ilmoittaa yrityksen nimi.',
        defaultMessage: 'Huomioithan, että jos palautuksen saajana on yritys, tulee tilinumeron haltijan nimeksi ilmoittaa yrityksen nimi.'
    },
    accountType: {
        id: 'Tilityyppi',
        defaultMessage: 'Tilityyppi'
    },
    authError: {
        id: 'Tunnistautuminen epäonnistui. Ole hyvä ja yritä uudelleen.',
        defaultMessage: 'Tunnistautuminen epäonnistui. Ole hyvä ja yritä uudelleen.'
    },
    govidSearchError: {
        id: 'Tapahtui virhe. Haku epäonnistui.',
        defaultMessage: 'Tapahtui virhe. Haku epäonnistui.'
    },
    noOpen: {
        id: 'Henkilötiedoillasi ei löytynyt avoimia laskuja.',
        defaultMessage: 'Henkilötiedoillasi ei löytynyt avoimia laskuja.'
    },
    noOpenCompany: {
        id: 'Y-tunnuksella ei löytynyt avoimia laskuja.',
        defaultMessage: 'Y-tunnuksella ei löytynyt avoimia laskuja.'
    },
    noArchivedInvoices: {
        id: 'Arkistoituja laskuja ei löytynyt',
        defaultMessage: 'Arkistoituja laskuja ei löytynyt'
    },
    searching: {
        id: 'Haetaan...',
        defaultMessage: 'Haetaan...'
    },
    pleaseTryAgain: {
        id: "Tapahtui virhe. Ole hyvä ja yritä uudelleen.",
        defaultMessage: "Tapahtui virhe. Ole hyvä ja yritä uudelleen."
    },
    jobNotFound: {
        id: "Virheelliset hakutiedot. Haku lukitaan viiden virheellisen haun jälkeen.",
        defaultMessage: "Virheelliset hakutiedot. Haku lukitaan viiden virheellisen haun jälkeen."
    },
    invoiceNotFoundFromLink: {
        id: "Laskua ei löytynyt. Alla näytetään omat laskusi.",
        defaultMessage: "Laskua ei löytynyt. Alla näytetään omat laskusi."
    },
    notAllowedToSign: {
        id: "Ei nimenkirjoitusoikeutta.",
        defaultMessage: "Ei nimenkirjoitusoikeutta."
    },
    searchLocked: {
        id: "Liian monta virheellistä hakua. Turvallisuussyistä haku on lukittu 30 minuutiksi.",
        defaultMessage: "Liian monta virheellistä hakua. Turvallisuussyistä haku on lukittu 30 minuutiksi."
    },
    forbiddenError: {
        id: "Haku estetty.",
        defaultMessage: "Haku estetty."
    },
    searchTitle: {
        id: "Hae laskua tai ilmoita tilinumero",
        defaultMessage: "Hae laskua tai ilmoita tilinumero"
    },
    unknownError: {
        id: "Jotain meni vikaan, ole hyvä ja yritä uudelleen.",
        defaultMessage: "Jotain meni vikaan, ole hyvä ja yritä uudelleen."
    },
    caseNumber: {
        id: "Asianumero",
        defaultMessage: "Asianumero"
    },
    onlineId: {
        id: "MyRopo-tunnus",
        defaultMessage: "MyRopo-tunnus"
    },
    reference: {
        id: "Maksuviite",
        defaultMessage: "Maksuviite"
    },
    creditor: {
        id: "Velkoja",
        defaultMessage: "Velkoja"
    },
    returnAmount: {
        id: "Palautettava määrä",
        defaultMessage: "Palautettava määrä"
    },
    refundProcessingFee: {
        id: "Maksun palautuksen käsittelykulu",
        defaultMessage: "Maksun palautuksen käsittelykulu"
    },
    accountNumber: {
        id: "Tilinumero",
        defaultMessage: "Tilinumero"
    },
    accountNumberInclClearing: {
        id: "Tilinumero sisältäen clearing-numeron",
        defaultMessage: "Tilinumero sisältäen clearing-numeron"
    },
    bic: {
        id: "BIC",
        defaultMessage: "BIC"
    },
    defaultErrorMessage: {
        id: "Tapahtui virhe. Ole hyvä ja yritä uudelleen.",
        defaultMessage: "Tapahtui virhe. Ole hyvä ja yritä uudelleen."
    },
    actionSaving: {
        id: "Tallennetaan tietoja...",
        defaultMessage: "Tallennetaan tietoja..."
    },
    iban: {
        id: "IBAN",
        defaultMessage: "IBAN"
    },
    bban: {
        id: "BBAN (Tilinumero)",
        defaultMessage: "BBAN (Tilinumero)"
    },
    bankgiro: {
        id: "BankGiro",
        defaultMessage: "BankGiro"
    },
    plusgirot: {
        id: "PlusGirot",
        defaultMessage: "PlusGirot"
    },
    bicCodeInvalid: {
        id: "Virheellinen BIC",
        defaultMessage: "Virheellinen BIC"
    },
    invalidIbanFormat: {
        id: "Tilinumero ei ole IBAN-muodossa.",
        defaultMessage: "Tilinumero ei ole IBAN-muodossa."
    },
    invalidBankgiroFormat: {
        id: "Virheellinen Bankgiro-tilinumero.",
        defaultMessage: "Virheellinen Bankgiro-tilinumero."
    },
    invalidPlusgirotFormat: {
        id: "Virheellinen Plusgirot-tilinumero.",
        defaultMessage: "Virheellinen Plusgirot-tilinumero."
    },
    invalidBbanFormat: {
        id: "Virheellinen Bban-tilinumero.",
        defaultMessage: "Virheellinen Bban-tilinumero."
    },
    bicFromIbanFail: {
        id: "BIC-koodia ei voi saada ibanista.",
        defaultMessage: "BIC-koodia ei voi saada ibanista."
    },
    overpaidRefundInProgress: {
        id: "Maksutietojen vastaanottaminen käynnissä, ole hyvä ja odota.",
        defaultMessage: "Maksutietojen vastaanottaminen käynnissä, ole hyvä ja odota."
    },
    overpaidInformation1: {
        id: "Olemme vastaanottaneet ilmoittamasi tilinumeron",
        defaultMessage: "Olemme vastaanottaneet ilmoittamasi tilinumeron"
    },
    overpaidInformation2: {
        id: "nimellä",
        defaultMessage: "nimellä"
    },
    searchingForJob: {
        id: "Etsitään laskua...",
        defaultMessage: "Etsitään laskua..."
    },
    openingInvoice: {
        id: "Avataan laskua",
        defaultMessage: "Avataan laskua"
    },
    openInvoice: {
        id: "Avaa lasku",
        defaultMessage: "Avaa lasku"
    },
    searchResults: {
        id: "Hakutulokset",
        defaultMessage: "Hakutulokset"
    },
    noSearchResults: {
        id: "Listauksesta ei löytynyt yhtään laskua annetulla hakuparametrillä (laskuttajan nimi, laskun numero, laskun viite tai asianumero).",
        defaultMessage: "Listauksesta ei löytynyt yhtään laskua annetulla hakuparametrillä (laskuttajan nimi, laskun numero, laskun viite tai asianumero)."
    },
    openRetrieveInvoiceLabel: {
        id: "Avaa Hae lasku -osio",
        defaultMessage: "Avaa Hae lasku -osio"
    },
    returnPaymentLabel: {
        id: "Avaa Ilmoita pankkitilin numero -osio",
        defaultMessage: "Avaa Ilmoita pankkitilin numero -osio"
    },
    logInForAllInvoices: {
        id: "Kirjaudu sisään nähdäksesi muiden yritysten laskut",
        defaultMessage: "Kirjaudu sisään nähdäksesi muiden yritysten laskut"
    },
    previousStep: {
        id: "Edellinen vaihe",
        defaultMessage: "Edellinen vaihe"
    },
    progress: {
        id: "Edistyminen",
        defaultMessage: "Edistyminen"
    },
    close: {
        id: "Sulje",
        defaultMessage: "Sulje"
    },
    saveDetailsForFutureRefunds: {
        id: "Tallenna tiedot tulevia maksunpalautuksia varten",
        defaultMessage: "Tallenna tiedot tulevia maksunpalautuksia varten"
    },
    chatTemporarilyUnavailable: {
        id: "Chat-palvelumme on tilapäisesti poissa käytöstä. Muut asiakaspalvelukanavamme toimivat normaalisti. MyRopossa voit hoitaa maksuasioita itsenäisesti tai ottaa yhteyttä viestikeskuksen kautta.",
        defaultMessage: "Chat-palvelumme on tilapäisesti poissa käytöstä. Muut asiakaspalvelukanavamme toimivat normaalisti. MyRopossa voit hoitaa maksuasioita itsenäisesti tai ottaa yhteyttä viestikeskuksen kautta."
    },
    processingAlertTitle: {
        id: 'Maksuasi käsitellään.',
        defaultMessage: 'Maksuasi käsitellään.'
    },
    processingAlertInfo: {
        id: 'Käsittely voi kestää 1–3 arkipäivää. Avoin saldo päivitetään, kun maksu on vastaanotettu ja kirjattu järjestelmäämme.',
        defaultMessage: 'Käsittely voi kestää 1–3 arkipäivää. Avoin saldo päivitetään, kun maksu on vastaanotettu ja kirjattu järjestelmäämme.'
    },
    paymentFailureAlertTitle: {
        id: 'Maksu epäonnistui {date}.',
        defaultMessage: 'Maksu epäonnistui {date}.'
    },
    paymentFailureAlertInfo: {
        id: 'Maksun käsittely ei onnistunut. Ole hyvä ja yritä uudelleen.',
        defaultMessage: 'Maksun käsittely ei onnistunut. Ole hyvä ja yritä uudelleen.'
    }
});

export default messages;
